module.exports = __webpack_public_path__ + "41208d8b679a5c286f3b0c98eae7fd00.png";